import script from "./MFACheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./MFACheck.vue?vue&type=script&lang=ts&setup=true"

import "./MFACheck.vue?vue&type=style&index=0&id=2b98b526&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./locale/MFACheck.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CJenkins%5Cworkspace%5CPlatformIdentity_master%5Cfrontend%5Clogin%5Csrc%5Cviews%5CMFACheck.vue&lang=yaml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b98b526"]])

export default __exports__